"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const components_1 = require("components");
const tooltip_icon_svg_1 = __importDefault(require("images/utility-icons/tooltip-icon.svg"));
const AnnouncementBanner = ({ callback, btnText, bodyText, fullWidth, }) => {
    return ((0, jsx_runtime_1.jsxs)("div", { className: `announcement-banner ${fullWidth ? 'w100' : 'width-initial'}`, children: [(0, jsx_runtime_1.jsxs)("div", { className: "announcement-description", children: [(0, jsx_runtime_1.jsx)("img", { src: tooltip_icon_svg_1.default, alt: "information", className: "tooltip-icon" }), (0, jsx_runtime_1.jsx)("p", { children: bodyText })] }), (0, jsx_runtime_1.jsx)(components_1.Button, { onClick: callback, className: "button-warn route-to-new-deal", "data-testid": "update-info-mark-complete-button", type: "button", children: btnText })] }));
};
exports.default = AnnouncementBanner;
